import { Controller } from "@hotwired/stimulus"

// Toggles a FAQ item: button flips aria-expanded, paired panel drops its
// hidden attribute, and the closest .faq-item gains the .open class so
// CSS can animate (max-height) and rotate the +/- icon.
//
// Set data-bd-faq-accordion-single-value="true" on the controller root
// to enforce single-open behaviour (clicking one closes the others).
// Default is multi-open.
//
// Usage:
//   <div data-controller="bd-faq-accordion"
//        data-bd-faq-accordion-single-value="true">
//     <div class="faq-item">
//       <button type="button" aria-expanded="false" aria-controls="faq-1"
//               data-action="click->bd-faq-accordion#toggle">Q</button>
//       <div id="faq-1" data-bd-faq-accordion-target="panel" hidden>A</div>
//     </div>
//   </div>
export default class extends Controller {
  static targets = ["panel"]
  static values = { single: Boolean }

  toggle(event) {
    const trigger = event.currentTarget
    const expanded = trigger.getAttribute("aria-expanded") === "true"

    if (this.singleValue) this.collapseAll()

    trigger.setAttribute("aria-expanded", String(!expanded))
    const panelId = trigger.getAttribute("aria-controls")
    const panel = this.panelTargets.find((p) => p.id === panelId)
    if (!panel) return
    panel.hidden = expanded

    const item = trigger.closest(".faq-item")
    if (item) item.classList.toggle("open", !expanded)
  }

  collapseAll() {
    this.element.querySelectorAll(".faq-q[aria-expanded='true']").forEach((btn) => {
      btn.setAttribute("aria-expanded", "false")
      const item = btn.closest(".faq-item")
      if (item) item.classList.remove("open")
    })
    this.panelTargets.forEach((p) => { p.hidden = true })
  }
}
